import axios from "../../axios/interceptor"
import Toast from "../../component/toastify/Index";

export const getBillingPlans = async (payload) => {
    try {
        const response = await axios.get('/customer/billing/billingPlan', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message ? error?.response?.data?.message ? error?.response?.data?.message : error?.message : error?.message, "error");
    }
}

export const getPaymentDetails = async () => {
    try {
        const response = await axios.get('/customer/billing/paymentDetail')
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message ? error?.response?.data?.message ? error?.response?.data?.message : error?.message : error?.message, "error");
    }
}


export const paymentConfirmed = async (id, isFreeTrailPurchased, isYearly) => {
    try {
        const response = await axios.put(`/customer/billing/paymentConfirmation/${id}`, { isFreeTrailPurchased, isYearly })
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message ? error?.response?.data?.message ? error?.response?.data?.message : error?.message : error?.message, "error");
    }
}